import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  messageCard: {
    backgroundColor: "#ffffff",
    borderTop: "1px solid #E0E0E0",
    borderBottom: "1px solid #E0E0E0",
    borderRight: "1px solid #E0E0E0",
    borderLeft: "5px solid #ec6535",
    borderRadius: "4px",
    padding: "16px 20px",
    marginBottom: "16px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
    position: "relative",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#fafbfc",
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.12)",
      borderLeftWidth: "6px",
    },
    "&:last-child": {
      marginBottom: "0px",
    },
  },
  messageHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "16px",
    paddingBottom: "14px",
    borderBottom: "1px solid #E5E7EB",
    gap: "16px",
  },
  headerLeft: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    flex: 1,
    minWidth: 0,
  },
  timestamp: {
    fontSize: "13px",
    color: "#6B7280",
    fontWeight: 600,
    lineHeight: 1.5,
    letterSpacing: "0.01em",
    marginBottom: "0",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.up(1680)]: {
      fontSize: "14px",
    },
  },
  batchInfo: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
    marginTop: "0",
  },
  batchNumber: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#111827",
    letterSpacing: "0.01em",
    lineHeight: 1.5,
    fontFamily: theme.typography.fontFamily,
    [theme.breakpoints.up(1680)]: {
      fontSize: "17px",
    },
  },
  messageTypeChip: {
    height: "26px",
    fontSize: "11px",
    fontWeight: 600,
    background: "linear-gradient(82deg, #3B173F 0%, #073270 100%) 0% 0% no-repeat padding-box",
    color: "#ffffff",
    borderRadius: "13px",
    boxShadow: "0 2px 4px rgba(59, 23, 63, 0.25)",
    border: "none",
    "& .MuiChip-label": {
      padding: "0 12px",
      lineHeight: "26px",
      letterSpacing: "0.3px",
      fontWeight: 600,
    },
    "&:hover": {
      background: "linear-gradient(82deg, #3B173F 0%, #073270 100%) 0% 0% no-repeat padding-box",
      opacity: 0.9,
    },
  },
  procedureNumber: {
    fontSize: "12px",
    color: "#64748b",
    fontStyle: "normal",
    fontWeight: 500,
    letterSpacing: "0.01em",
    marginTop: "0",
  },
  messageContent: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
    gap: "12px 20px",
    margin: 0,
    padding: 0,
  },
  contentItem: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    padding: "8px 0",
    borderBottom: "none",
  },
  contentLabel: {
    fontSize: "13px",
    fontWeight: 600,
    textTransform: "none",
    letterSpacing: "0.01em",
    lineHeight: 1.4,
    marginBottom: "4px",
    color: "#374151",
    fontFamily: theme.typography.fontFamily,
    whiteSpace: "normal",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    [theme.breakpoints.up(1680)]: {
      fontSize: "14px",
    },
  },
  contentValue: {
    fontSize: "14px",
    fontWeight: 400,
    wordBreak: "break-word",
    lineHeight: 1.6,
    letterSpacing: "0.01em",
    color: "#111827",
    marginTop: "0",
    display: "block",
    fontFamily: theme.typography.fontFamily,
    [theme.breakpoints.up(1680)]: {
      fontSize: "15px",
      lineHeight: 1.65,
      fontFamily: theme.typography.fontFamily,
    },
  },
}));

